module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-1-1 text-dark"
  }, [_c('div', {
    staticClass: "flex column"
  }, [_c('div', {
    staticClass: "hours_show__header width-100"
  }, [_c('div', {
    staticClass: "flex space-between"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.title')))]), _vm._v(" "), _c('h1', {
    staticClass: "only-print right"
  }, [_vm._v(_vm._s(_vm._f("L")(_vm.startDate)) + " - " + _vm._s(_vm._f("L")(_vm.endDate)))]), _vm._v(" "), _c('div', {
    staticClass: "flex align-center"
  }, [_c('p', {
    staticClass: "marg-10-right bold no-print"
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.choose_period')))]), _vm._v(" "), _c('datePickerRange', {
    staticClass: "inline-block align-center flex no-print",
    attrs: {
      "allowSameDate": true,
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.startDateChanged,
      "endchanged": _vm.endDateChanged
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "marg-10-left no-print",
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  })])], 1)]), _vm._v(" "), _c('HoursShowShortcuts', {
    attrs: {
      "start": _vm.start,
      "end": _vm.end
    }
  }), _vm._v(" "), _c('dSelectUsers', {
    attrs: {
      "showTags": true,
      "showCreateButton": false
    },
    on: {
      "usersUpdated": _vm.syncUsers
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filters marg-20-top marg-10-bottom flex"
  }, [_c('div', {
    staticClass: "fl-icon icon-filter"
  }), _vm._v(" "), _c('button', {
    staticClass: "filter",
    class: {
      'active': _vm.filterIsActive(null)
    },
    on: {
      "click": function($event) {
        return _vm.setEventsFilter(null)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.all')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "filter",
    class: {
      'active': _vm.filterIsActive('subject')
    },
    on: {
      "click": function($event) {
        return _vm.setEventsFilter('subject')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.teaching')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "filter",
    class: {
      'active': _vm.filterIsActive('substituteHours')
    },
    on: {
      "click": function($event) {
        return _vm.setEventsFilter('substituteHours')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.substitute_hours')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "filter",
    class: {
      'active': _vm.filterIsActive('absence')
    },
    on: {
      "click": function($event) {
        return _vm.setEventsFilter('absence')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.absence')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "hours_show__body width-100"
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('Spinner', {
    attrs: {
      "color": "blue"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "user-list"
  }, _vm._l((_vm.usersAndEventsWithProps), function(user) {
    return _c('li', {
      key: user.user_id,
      staticClass: "user-list__user"
    }, [_c('div', {
      staticClass: "user-list__user__header"
    }, [_c('h2', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
      staticClass: "user-list__user__right"
    }, [_c('p', [_vm._v(_vm._s(Object.keys(user.v_events_filtered).length) + " " + _vm._s(_vm.$t('vue2.substitute_hours.work_days')) + ": "), _c('b', [_vm._v(_vm._s(user.v_all_days_duration))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.v_filter_events.length) + "\n                "), (user.v_filter_events.length < 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_event')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_events')))]), _vm._v(":\n                "), _c('b', [_vm._v(_vm._s(_vm.getSumDuration(user.v_filter_events)))])])])]), _vm._v(" "), _c('ul', {
      staticClass: "user-list__events"
    }, _vm._l((user.v_events_filtered), function(dayEvents) {
      return _c('li', {
        key: dayEvents[0].start_time,
        staticClass: "user-list__events_day"
      }, [_c('div', {
        staticClass: "user-list__events_day__header"
      }, [_c('div', [_c('span', {
        staticClass: "day-headline"
      }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("ddd")(dayEvents[0].start_time))) + ", " + _vm._s(_vm._f("LL")(dayEvents[0].start_time)))]), _vm._v(",\n                  kl. " + _vm._s(_vm._f("LT")(dayEvents[0].start_time)) + " - " + _vm._s(_vm._f("LT")(dayEvents[dayEvents.length - 1].end_time)) + ", " + _vm._s(_vm.getDayDuration(dayEvents)) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "user-list__events_day__header__day-events"
      }, [_c('p', [_vm._v(_vm._s(dayEvents.length) + "\n                    "), (dayEvents.length < 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_event')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitute_hours.calendar_events')))]), _vm._v(" -\n                    " + _vm._s(_vm.getSumDuration(dayEvents)) + "\n                  ")])])]), _vm._v(" "), _c('ul', {
        staticClass: "user-list__event_day__lessons"
      }, _vm._l((dayEvents), function(event) {
        return _c('li', {
          key: event.event_id,
          staticClass: "lesson",
          style: ({
            'borderColor': event.color
          })
        }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm._f("LT")(event.start_time)) + " - " + _vm._s(_vm._f("LT")(event.end_time)) + " | " + _vm._s(event.title) + " "), (_vm.eventHasAnyKlass(event.klasses)) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" " + _vm._s(_vm._f("klassList")(event.klasses)) + "\n                  ")]), _vm._v(" "), (event.substitute_for) ? _c('div', [_c('span', {
          staticClass: "icon-users3"
        }), _vm._v(_vm._s(_vm.$t('vue2.substitute_hours.substitute_for')) + ":\n                    " + _vm._s(event.substitute_for) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.getEventDuration(event)) + "\n                  ")])])
      }), 0)])
    }), 0)])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ad68305!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hours/HoursShow.vue
// module id = 1744
// module chunks = 1